import Cookie from 'js-cookie';

export const createCookie = (response) => {
    if (window.location.origin.indexOf('localhost') !== -1) {
        Cookie.set(process.env.REACT_APP_TOKEN, response.signInUserSession.idToken.jwtToken);
    }

    Cookie.set(process.env.REACT_APP_TOKEN, response.signInUserSession.idToken.jwtToken, {
        domain: process.env.REACT_APP_DOMAIN,
    });
};

export const createCookieFromToken = (token) => {
    if (window.location.origin.indexOf('localhost') !== -1) {
        Cookie.set(process.env.REACT_APP_TOKEN, token);
    }

    Cookie.set(process.env.REACT_APP_TOKEN, token, {
        domain: process.env.REACT_APP_DOMAIN,
    });
};

export const clearCookie = () => {
    localStorage.clear();
    sessionStorage.clear();
    if (window.location.origin.indexOf('localhost') !== -1) {
        Cookie.remove(process.env.REACT_APP_TOKEN);
    }

    Cookie.remove(process.env.REACT_APP_TOKEN, {
        domain: process.env.REACT_APP_DOMAIN,
    });
    Object.keys(Cookie.get()).forEach((item) => {
        Cookie.remove(item, {
            domain: process.env.REACT_APP_DOMAIN,
        });
    });
};

export const createCookieFarm = (farm) => {
    if (window.location.origin.indexOf('localhost') !== -1) {
        Cookie.set(process.env.REACT_APP_WEB_FARM, farm);
    }

    Cookie.set(process.env.REACT_APP_WEB_FARM, farm, {
        domain: process.env.REACT_APP_DOMAIN,
    });
};

export const createCookieFarmStore = (farmId) => {
    if (window.location.origin.indexOf('localhost') !== -1) {
        Cookie.set(process.env.REACT_APP_WEB_FARM_STORE, farmId);
    }

    Cookie.set(process.env.REACT_APP_WEB_FARM_STORE, farmId, {
        domain: process.env.REACT_APP_DOMAIN,
    });
};

export const createCookieUserStore = (userId) => {
    if (window.location.origin.indexOf('localhost') !== -1) {
        Cookie.set(process.env.REACT_APP_WEB_USER_STORE, userId);
    }

    Cookie.set(process.env.REACT_APP_WEB_USER_STORE, userId, {
        domain: process.env.REACT_APP_DOMAIN,
    });
};

export const createCookieCustomerStore = (customerId) => {
    if (window.location.origin.indexOf('localhost') !== -1) {
        Cookie.set(process.env.REACT_APP_WEB_CUSTOMER_STORE, customerId);
    }

    Cookie.set(process.env.REACT_APP_WEB_CUSTOMER_STORE, customerId, {
        domain: process.env.REACT_APP_DOMAIN,
    });
};

export const createCookieIw = (token) => {
    if (window.location.origin.indexOf('localhost') !== -1) {
        Cookie.set(process.env.REACT_APP_TOKEN_IW, token);
    }

    Cookie.set(process.env.REACT_APP_TOKEN_IW, token, {
        domain: process.env.REACT_APP_DOMAIN,
    });
};